import parseBoolean from './config/parseBoolean';
import './pt-logic-memory-rs.css';
import { getModelFromInputAtPosition } from '../../common/getModelFunctions';

export default {
	model: {
		value: {
			default: false
		}
	},
	computed: {
		input_set() {
			const inputs = this.$el.dataset.inputs.split(',');

			return parseBoolean(getModelFromInputAtPosition(this.$model, inputs, 0));
		},
		input_reset() {
			const inputs = this.$el.dataset.inputs.split(',');

			return parseBoolean(getModelFromInputAtPosition(this.$model, inputs, 1));
		}
	},
	watch: {
		input_set() {
			if (this.data.input_set && !this.data.input_reset) this.data.value = true;
			else if (this.data.input_reset) this.data.value = false;
		},
		input_reset() {
			if (this.data.input_reset) this.data.value = false;
			else this.data.value = this.data.input_set || false;
		}
	},
	listeners: {
		click: true
	}
};
